import { IOfferEventType } from 'graphql/types';
import { OFFER_TYPE_FILTERS } from 'offer/constants/offer';

export function getFilterForType(type: IOfferEventType) {
    return OFFER_TYPE_FILTERS.find((filter) => filter.types.includes(type));
}
